import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
// Fonte única (Inter) é self-hospedada em src/assets/fonts e declarada via
// @font-face no tema (theme/index.ts) — nada de @fontsource aqui.

// Limpeza one-shot: chaves antigas de localStorage que armazenavam tokens
// (vetor de XSS antes da migração para cookies HttpOnly). Pode ser
// removida após alguns deploys (quando todos os clientes já tiverem
// passado por aqui pelo menos uma vez).
;['token', 'refreshToken', 'usuario'].forEach((k) => {
  try { localStorage.removeItem(k) } catch { /* ignore */ }
})

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
)
